const map = {
	"./(auth)/_layout": 38839,
	"./(auth)/_layout.tsx": 38839,
	"./(auth)/recover": 41099,
	"./(auth)/recover.tsx": 41099,
	"./(auth)/reset-password": 72984,
	"./(auth)/reset-password.tsx": 72984,
	"./(auth)/signin": 39591,
	"./(auth)/signin.tsx": 39591,
	"./(auth)/signup": 48108,
	"./(auth)/signup.tsx": 48108,
	"./(tabs)": 57826,
	"./(tabs)/": 57826,
	"./(tabs)/_layout": 41697,
	"./(tabs)/_layout.tsx": 41697,
	"./(tabs)/catalogo": 41762,
	"./(tabs)/catalogo.tsx": 41762,
	"./(tabs)/index": 57826,
	"./(tabs)/index.tsx": 57826,
	"./(tabs)/perfil": 86486,
	"./(tabs)/perfil/": 86486,
	"./(tabs)/perfil/_layout": 63252,
	"./(tabs)/perfil/_layout.tsx": 63252,
	"./(tabs)/perfil/debug": 89315,
	"./(tabs)/perfil/debug.tsx": 89315,
	"./(tabs)/perfil/excluir-conta": 98359,
	"./(tabs)/perfil/excluir-conta.tsx": 98359,
	"./(tabs)/perfil/index": 86486,
	"./(tabs)/perfil/index.tsx": 86486,
	"./(tabs)/perfil/preferencias": 99270,
	"./(tabs)/perfil/preferencias.tsx": 99270,
	"./(tabs)/preco/[projectId]": 70291,
	"./(tabs)/preco/[projectId].tsx": 70291,
	"./(tabs)/projeto/[id]": 27467,
	"./(tabs)/projeto/[id].tsx": 27467,
	"./_layout": 6512,
	"./_layout.tsx": 6512,
	"./onboarding": 83713,
	"./onboarding.tsx": 83713,
	"./sessao/[projectId]": 94511,
	"./sessao/[projectId].tsx": 94511
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35154;